import { Box, Stack, Typography } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import { Dayjs } from "dayjs";
import { ReactNode } from "react";
import { XTextField } from "share-components/mui-wrap/text-field/x-text-field";
export type FromToDateProps = {
  label?: ReactNode;
  fromDate: Dayjs | null;
  toDate: Dayjs | null;
  onFromDateChanged?: (newValue: Dayjs | null) => void;
  onToDateChanged?: (newValue: Dayjs | null) => void;
  periodOfTime?: number; // day
};
export const DateRange = ({
  label,
  fromDate,
  toDate,
  onFromDateChanged,
  onToDateChanged,
  periodOfTime,
}: FromToDateProps) => {
  return (
    <Stack direction={"row"} alignItems={"center"} spacing={1}>
      {label && <Typography variant="subtitle2">{`${label}:`}</Typography>}
      <Stack direction={"row"} alignItems={"center"}>
        <DatePicker
          value={fromDate}
          label={"Từ"}
          onChange={(newValue) => {
            onFromDateChanged?.(newValue);
          }}
          renderInput={(params) => <XTextField {...params} fullWidth />}
          // minDate={
          //   toDate && periodOfTime
          //     ? toDate.subtract(periodOfTime, "day")
          //     : undefined
          // }
          // maxDate={toDate || undefined}
        />
        <Box sx={{ paddingLeft: "5px", paddingRight: "5px" }}>-</Box>
        <DatePicker
          value={toDate}
          label={"Đến"}
          onChange={(newValue) => {
            onToDateChanged?.(newValue);
          }}
          renderInput={(params) => <XTextField {...params} fullWidth />}
          // minDate={fromDate || undefined}
          // maxDate={
          //   fromDate && periodOfTime
          //     ? fromDate.add(periodOfTime, "day")
          //     : undefined
          // }
        />
      </Stack>
    </Stack>
  );
};
